export const normal = function (vertices) {
    return [...vertices];
};
//# sourceMappingURL=normal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6/es/registry/router/normal.js
// module id = null
// module chunks = 